module.exports = __webpack_public_path__ + "static/media/cat-food-beverage.2d2d5421.jpg";